import { styled } from '@mui/material';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Dialog } from 'shell/components/Dialog';
import IconButton from 'shell/components/IconButton';
import Text from 'shell/components/Text';

const VideoDialog = memo(({ videoId, ...rest }) => {
    const { t } = useTranslation();

    return (
        <CustomDialog aria-labelledby={'dialog-title'} {...rest}>
            <Text sx={{ zIndex: '-1' }} id={'dialog-title'} component={'h1'}>
                {t('ui.embedded-youtube-video', 'Embedded YouTube Video')}
            </Text>
            <CustomIconButton
                aria-label={'close video'}
                kind={'exit'}
                size={'medium'}
                variant={'circle'}
                onClick={rest.onClose}
            />
            <iframe
                width={'100%'}
                height={'100%'}
                src={`https://www.youtube.com/embed/${videoId}`}
                allow={'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'}
                allowFullScreen
                title={'Embedded YouTube Video'}
            />
        </CustomDialog>
    );
});

const CustomDialog = styled(Dialog)(({ theme }) => {
    return {
        '& .MuiDialog-paper': {
            borderRadius: 0,
            margin: 0,
            maxWidth: '968px',
            width: '100%',
            padding: theme.spacing(8),
            aspectRatio: '16 / 10',
            background: 'transparent',
            overflow: 'hidden',
        },
        '& .MuiBox-root': {
            height: '100%',
            padding: 0,
        },
        '& iframe': {
            border: 0,
        },
    };
});

const CustomIconButton = styled(IconButton)(() => {
    return {
        position: 'absolute',
        top: '32px',
        right: '16px',
    };
});

export default VideoDialog;
